import React, { useState } from 'react';
import Select, {
	SelectValue,
} from '../../../../../Components/Base/Select/Select';
import {
	TermItem,
	useLazyTermItemsQuery,
} from '../../../../../graphql/graphql';
import { useEffectAsync } from '../../../../../helpers';
import useTranslation from '../../../../../Hooks/useTranslation';
import Loading from '../../../../../Components/Loading';
import useSelectValueGuard from '../../../Hooks/useSelectValueGuard';

interface CitizenshipSelectValue extends SelectValue {
	secondaryValue: string;
}

interface Props {
	onChange?: (value: SelectValue) => void;
	onLoad?: (citizenShips: TermItem[]) => void;
	value?: SelectValue;
}

const CitizenshipSelect: React.FC<Props> = ({ onChange, onLoad, value }) => {
	const [isLoading, setIsLoading] = useState(true);
	const [options, setOptions] = useState<CitizenshipSelectValue[]>([]);
	const [getTermItems] = useLazyTermItemsQuery();
	const { t } = useTranslation();

	useEffectAsync(async () => {
		const { termItems } = await getTermItems({
			termType: 'nationality',
		}).unwrap();

		const options: CitizenshipSelectValue[] = [];
		const citizenShips: TermItem[] = [];

		// @ts-ignore
		(termItems?.data || []).map((termItem: TermItem) => {
			if (termItem.name) {
				options.push({
					label: t(termItem.name) ?? termItem.id,
					value: termItem.id,
					secondaryValue: termItem.value ?? '-1',
				});
				citizenShips.push(termItem);
			}
		});

		onLoad?.(citizenShips);
		setOptions(options);
		setIsLoading(false);
	}, []);

	useSelectValueGuard({ onChange, options, value });

	if (isLoading) {
		return <Loading />;
	}

	return (
		<Select
			options={options}
			onChange={onChange}
			placeholder={t('base.shared.pick')}
			value={value}
		/>
	);
};
export default CitizenshipSelect;
